module.exports = __webpack_public_path__ + "img/02.0b186e0d.png";